/**
 * Route path segments on which the "Ask Opal" overlay button and chat panel are available.
 * Used by both the global header (to render the button) and the overlay (to stay open).
 */
export const OVERLAY_PAGE_SEGMENTS = [
  'instructions',
  'skills',
  'agents',
  'connectors',
  'context',
  'vaus',
];

/**
 * Route segments on which the top-toolbar Tracker toggle is available. The
 * Tracker is a personal board, so the toggle is reachable from every primary
 * destination — the overlay pages plus the other top-level instance pages
 * (chat, messages, artifacts, notifications, settings). Kept separate from
 * OVERLAY_PAGE_SEGMENTS so the "Ask Opal" overlay does NOT render on these
 * extra pages (e.g. /messages already hosts the chat MFE in messaging mode,
 * and /chat is the chat surface itself).
 */
export const TRACKER_PAGE_SEGMENTS = [
  ...OVERLAY_PAGE_SEGMENTS,
  'chat',
  'messages',
  'artifacts',
  'notifications',
  'settings',
];
